const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-circle-primary{fill:#008941;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.375 -3.375)"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon-circle-primary",
  d: "M51.465,29.325H35.977V13.838a3.326,3.326,0,0,0-6.652,0V29.325H13.838a3.186,3.186,0,0,0-3.326,3.326,3.22,3.22,0,0,0,3.326,3.326H29.325V51.465a3.222,3.222,0,0,0,3.326,3.326,3.309,3.309,0,0,0,3.326-3.326V35.977H51.465a3.326,3.326,0,0,0,0-6.652Z",
  transform: "translate(13.963 13.963)"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-circle-primary",
  d: "M46.615,9.2A37.425,37.425,0,0,1,73.078,73.078,37.425,37.425,0,0,1,20.151,20.151,37.171,37.171,0,0,1,46.615,9.2m0-5.821a43.24,43.24,0,1,0,43.24,43.24,43.233,43.233,0,0,0-43.24-43.24Z"
}));
function SvgIconionicIosAddCircleOutlinePrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.479,
    height: 86.479,
    viewBox: "0 0 86.479 86.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicIosAddCircleOutlinePrimary);
export default __webpack_public_path__ + "static/media/Icon ionic-ios-add-circle-outline-primary.9c83f5ee.svg";
export { ForwardRef as ReactComponent };